import {Component, HostListener} from '@angular/core';
import {ViewportScroller} from "@angular/common";
import {NavigationEnd, Router} from "@angular/router";
import {NGXLogger} from "ngx-logger";
import {MediaChange, MediaObserver} from "@ngbracket/ngx-layout";
import {NativeService} from '../../_service/native.service';

@Component({
  selector: 'app-floating-button',
  templateUrl: './floating-button.component.html',
  styleUrls: ['./floating-button.component.scss']
})
export class FloatingButtonComponent {
  showNewButton = false;
  showScrollButton = false;
  private listPage: string | undefined = undefined;
  private mobile = false;

  get isMyHouseInfoPage(): boolean {
    return this.router.url.split(/[?#]/)[0].replace(/\/+$/, '') === '/info/my-house';
  }

  get isAnalysisInfoPage(): boolean {
    const path = this.router.url.split(/[?#]/)[0].replace(/\/+$/, '');
    return ['/analysis/info', '/info/business-analysis-private', '/info/business-analysis-bridge'].includes(path);
  }

  get nativeIos(): boolean {
    return this.nativeService.isNativeiOS();
  }

  constructor(private readonly log: NGXLogger,
              private readonly media: MediaObserver,
              private readonly router: Router,
              private readonly nativeService: NativeService,
              private scroll: ViewportScroller) {

    this.media.asObservable().subscribe((change: MediaChange[]) => {
      this.mobile = change[0].mqAlias === 'xs';
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (!this.mobile) return;

        if (event.url.includes('/house/list')) {
          this.listPage = 'HOUSE_LIST';
          this.showNewButton = true;
        } else if (event.url.includes('/analysis/list')) {
          this.listPage = 'ANALYSIS_LIST';
          this.showNewButton = true;
        } else {
          this.listPage = undefined;
          this.showNewButton = false;
        }
      }
    });
  }

  @HostListener('window:scroll', ['$event.target'])
  onWindowScroll(document: any) {
    let scroll = document.scrollingElement.scrollTop;
    this.showScrollButton = scroll > window.visualViewport!.height;
  }

  clickNewButton() {
    if (!this.showNewButton || this.listPage === undefined) return;

    if (this.listPage === 'HOUSE_LIST') {
      this.router.navigateByUrl('/house/register?type=MY_HOUSE')
    } else if (this.listPage === 'ANALYSIS_LIST') {
      this.router.navigateByUrl('/analysis')
    }
  }

  scrollTop() {
    this.scroll.scrollToPosition([0, 1])
  }
}
